<ng-container *ngIf="reloadVisibility === 'data-visible'">
  <mat-progress-bar mode="indeterminate" [style.visibility]="_alternateLoadingVisibility$ | async" />
</ng-container>
<div class="async-ui__content" *ngIf="_showData$ | async">
  <ng-content />
</div>
<div class="async-ui__loading" *ngIf="_showLoading$ | async">
  <div #loadRef>
    <ng-content select="[loading]" />
  </div>
  <ng-container *ngIf="loadRef.children.length === 0">
    <mat-spinner [diameter]="24" [ngStyle]="{ margin: loadingMargin }" />
  </ng-container>
</div>
<div class="async-ui__error" *ngIf="_showError$ | async">
  <div #errRef>
    <ng-content select="[error]" />
  </div>
  <ng-container *ngIf="errRef.children.length === 0">
    <uikit-empty-state iconName="error_outline" title="Unable to Load Results" [ngStyle]="{ margin: errorMargin }" />
  </ng-container>
</div>
